import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'utils/fontAwesome';
import * as S from "./Login.styled";
import logo from 'assets/logo.png';
import { authService } from 'services/authService';
import { memberService } from 'services/memberService';

const ADMIN_TAP_COUNT = 5;
const TAP_RESET_MS = 1500;

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  const tapCountRef = useRef(0);
  const tapTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleLogoTap = () => {
    tapCountRef.current += 1;

    if (tapTimerRef.current) clearTimeout(tapTimerRef.current);

    if (tapCountRef.current >= ADMIN_TAP_COUNT) {
      tapCountRef.current = 0;
      navigate('/admin/login');
      return;
    }

    tapTimerRef.current = setTimeout(() => {
      tapCountRef.current = 0;
    }, TAP_RESET_MS);
  };

  const handleLogin = async () => {
    setErrorMessage('');

    if (!email.trim()) {
      setErrorMessage('이메일을 입력해주세요.');
      return;
    }

    if (!password.trim()) {
      setErrorMessage('비밀번호를 입력해주세요.');
      return;
    }

    try {
      const response = await authService.login({ email, password });

      localStorage.setItem('accessToken', response.accessToken);
      localStorage.setItem('refreshToken', response.refreshToken);
      localStorage.removeItem('guestMode');

      // Fetch user info and store universityId in localStorage
      try {
        const userInfo = await memberService.getMe();
        localStorage.setItem('universityId', String(userInfo.university.id));
      } catch (error) {
        console.error('Failed to fetch user info:', error);
      }

      navigate('/home');
    } catch (error: any) {
      console.error(error);
      if (error.response?.status === 401) {
        setErrorMessage('이메일 또는 비밀번호가 일치하지 않습니다.');
      } else if (error.response?.status === 404) {
        setErrorMessage('존재하지 않는 계정입니다.');
      } else {
        setErrorMessage('로그인에 실패했습니다. 다시 시도해주세요.');
      }
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  };

  return (
    <S.Page>
      <S.LogoWrap onClick={handleLogoTap} style={{ cursor: 'default' }}>
        <img alt='Logo' src={logo}/>
      </S.LogoWrap>

      <S.ContentWrap>
        <S.InputWrap style={{marginTop:'4vh'}}>
          <FontAwesomeIcon icon="circle-user" />
          <input
            placeholder='아이디'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </S.InputWrap>

        <S.InputWrap>
          <FontAwesomeIcon icon="lock" />
          <input
            placeholder='비밀번호'
            type='password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </S.InputWrap>

        {errorMessage && <S.ErrorMessage>{errorMessage}</S.ErrorMessage>}
      </S.ContentWrap>

      <S.BottomButton onClick={handleLogin}>로그인</S.BottomButton>
      <S.GuestButton onClick={() => navigate('/guest-select')}>로그인 없이 시작하기</S.GuestButton>

      <S.Bottom>
        <S.StyledLink to='/signup'>회원가입</S.StyledLink>
        <S.StyledLink to='/searchmain'>아이디/비밀번호 찾기</S.StyledLink>
      </S.Bottom>
    </S.Page>
  );
}

export default Login;
